import { useEffect, useRef, useState } from "react";

const faqs = [
  {
    category: "商品相關",
    icon: "ri-ancient-gate-line",
    color: "#8b6f47",
    bg: "#f5ede0",
    items: [
      {
        q: "如何確認天珠的真偽？",
        a: "瓏靖所有天珠均為親赴西藏、雲南等產地嚴格篩選，每一件商品皆附有材質說明卡。我們也提供購買後的鑑定諮詢服務，如有疑問歡迎透過 LINE 或電子郵件聯繫我們。",
      },
      {
        q: "水晶礦石需要定期淨化嗎？",
        a: "是的，建議每隔 1–2 個月進行一次能量淨化。常見的淨化方式包括月光淨化（滿月夜放置窗台）、煙燻淨化（鼠尾草或聖木）或音頻淨化（頌缽）。購買時我們會附上詳細的保養說明。",
      },
      {
        q: "翡翠玉石如何保養？",
        a: "翡翠玉石需避免碰撞、刮傷及接觸化學物質（如香水、清潔劑）。日常可用柔軟的棉布輕輕擦拭，保持光澤。避免長時間暴露在強烈陽光下，以防色澤變化。",
      },
      {
        q: "唐卡是手繪的嗎？",
        a: "是的，瓏靖所有唐卡均為藏族藝術家手工繪製，使用傳統天然礦物顏料，每一幅都是獨一無二的藝術品。我們不販售印刷品或複製品，請放心選購。",
      },
    ],
  },
  {
    category: "訂購與配送",
    icon: "ri-truck-line",
    color: "#4a7a52",
    bg: "#eaf2eb",
    items: [
      {
        q: "如何下訂單？",
        a: "目前可透過 LINE（@longjing）或電子郵件（service@longjing.com.tw）與我們聯繫下訂。我們將為您提供詳細的商品資訊、價格與付款方式，確認後即可完成訂購。",
      },
      {
        q: "配送需要多久時間？",
        a: "台灣本島一般 2–3 個工作天到貨；離島地區約 3–5 個工作天。訂製商品依製作時間而定，通常需要 7–14 個工作天，我們會在確認訂單時告知預計完成時間。",
      },
      {
        q: "可以指定配送時間嗎？",
        a: "可以，請在下訂時告知您希望的配送時間，我們將盡力配合安排。如需特定日期到貨（如生日禮物），請提前至少 5 個工作天告知。",
      },
      {
        q: "商品可以退換貨嗎？",
        a: "商品到貨後 7 天內，如有品質問題或與描述不符，可申請退換貨。請保持商品原包裝完整，並透過 LINE 或電子郵件聯繫我們，我們將盡快為您處理。",
      },
    ],
  },
  {
    category: "訂製服務",
    icon: "ri-hand-heart-line",
    color: "#7a6a9a",
    bg: "#f0edf7",
    items: [
      {
        q: "可以訂製專屬的能量飾品嗎？",
        a: "當然可以！我們提供個人化的能量飾品訂製服務。您可以告訴我們您的需求、喜好的材質、想要的能量方向（如招財、守護、愛情等），我們將為您設計專屬的飾品。",
      },
      {
        q: "訂製飾品需要多久時間？",
        a: "一般訂製飾品需要 7–14 個工作天，複雜設計或特殊材質可能需要更長時間。我們會在確認訂單後告知預計完成時間，並在製作過程中與您保持溝通。",
      },
      {
        q: "可以作為禮物訂製嗎？",
        a: "非常適合！我們提供精美的禮品包裝服務，並可附上手寫祝福卡片。如需送禮，請告知收禮人的基本資訊（如生日、星座、需要的能量方向），我們將為您推薦最適合的飾品。",
      },
    ],
  },
  {
    category: "能量諮詢",
    icon: "ri-sparkling-2-line",
    color: "#c9a96e",
    bg: "#faf5ec",
    items: [
      {
        q: "如何知道哪種飾品適合自己？",
        a: "我們提供免費的能量飾品諮詢服務。您可以告訴我們您目前的生活狀況、希望改善的面向（如事業、健康、感情等），我們將根據您的需求推薦最適合的飾品。",
      },
      {
        q: "天珠、水晶、玉石有什麼不同？",
        a: "三者各有其文化背景與能量特性：天珠源自藏傳文化，具有強大的守護能量；水晶礦石來自大自然，每種水晶對應不同的能量頻率；玉石則是東方文化中吉祥與品德的象徵。詳細說明可參考我們的知識專欄。",
      },
      {
        q: "佩戴能量飾品有什麼注意事項？",
        a: "建議在睡覺、洗澡或進行劇烈運動時取下飾品，以延長使用壽命。新購入的飾品建議先進行能量淨化，再開始佩戴。如有特殊宗教信仰或禁忌，請在諮詢時告知我們。",
      },
    ],
  },
];

export default function FAQ() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [openItems, setOpenItems] = useState<Record<string, boolean>>({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const toggleItem = (key: string) => {
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <section className="py-20 md:py-28 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#8b6f47]"></span>
            <span
              className="text-[#8b6f47] text-[1rem] tracking-[0.3em] font-medium"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              FAQ
            </span>
            <span className="w-10 h-px bg-[#8b6f47]"></span>
          </div>
          <h2
            className="text-[#2d2520] font-bold mb-4 leading-[1.4]"
            style={{
              fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            常見問題
          </h2>
          <p
            className="text-[#7a6a5a] max-w-xl mx-auto leading-[1.75]"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            整理了最常被問到的問題，希望能幫助您更快找到所需的資訊。
          </p>
        </div>

        {/* FAQ Categories */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {faqs.map((category, ci) => (
            <div
              key={category.category}
              className={`transition-all duration-1000`}
              style={{
                transitionDelay: `${ci * 100}ms`,
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(24px)",
              }}
            >
              {/* Category Header */}
              <div className="flex items-center gap-3 mb-6">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ backgroundColor: category.bg }}
                >
                  <i className={`${category.icon} text-lg`} style={{ color: category.color }}></i>
                </div>
                <h3
                  className="text-[#2d2520] font-bold"
                  style={{
                    fontSize: "clamp(1.125rem, 1.5vw, 1.375rem)",
                    fontFamily: "'Noto Serif TC', serif",
                  }}
                >
                  {category.category}
                </h3>
              </div>

              {/* FAQ Items */}
              <div className="space-y-3">
                {category.items.map((item, ii) => {
                  const key = `${ci}-${ii}`;
                  const isOpen = openItems[key];
                  return (
                    <div
                      key={key}
                      className="border border-[#e8e0d5] rounded-xl overflow-hidden"
                    >
                      <button
                        onClick={() => toggleItem(key)}
                        className="w-full flex items-start justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-[#faf8f4] transition-colors"
                      >
                        <span
                          className="text-[#2d2520] font-medium leading-[1.5] flex-1"
                          style={{
                            fontSize: "1.1875rem",
                            fontFamily: "'Noto Serif TC', serif",
                          }}
                        >
                          {item.q}
                        </span>
                        <span
                          className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5 transition-all duration-300 ${
                            isOpen ? "bg-[#8b6f47] text-white rotate-45" : "bg-[#f0e8dc] text-[#8b6f47]"
                          }`}
                        >
                          <i className="ri-add-line text-sm"></i>
                        </span>
                      </button>
                      <div
                        className={`overflow-hidden transition-all duration-400 ${
                          isOpen ? "max-h-96" : "max-h-0"
                        }`}
                      >
                        <div className="px-6 pb-5 border-t border-[#f0e8dc]">
                          <p
                            className="text-[#7a6a5a] leading-[1.75] pt-4"
                            style={{
                              fontSize: "1.1875rem",
                              fontFamily: "'Noto Serif TC', serif",
                            }}
                          >
                            {item.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Still have questions */}
        <div
          className={`mt-16 text-center transition-all duration-1000 delay-400 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-[#f5f0e8] rounded-2xl px-8 py-6">
            <p
              className="text-[#5a4e45] text-[1.1875rem]"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              還有其他問題嗎？
            </p>
            <a
              href="https://line.me"
              rel="nofollow"
              target="_blank"
              className="inline-flex items-center gap-2 px-7 py-3 bg-[#8b6f47] text-white rounded-full text-[1rem] font-medium cursor-pointer hover:bg-[#7a5f3a] transition-colors whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              <i className="ri-line-line text-lg"></i>
              LINE 即時諮詢
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
